import React, { useRef } from "react";

const ConfirmationModal = ({ isOpen, onClose, onCreateAccount, onSignIn }) => {
    const modalRef = useRef(null);

    // Handle closing the modal when clicking outside
    const handleClickOutside = (event) => {
        if (modalRef.current && !modalRef.current.contains(event.target)) {
            onClose();
        }
    };

    // Add an event listener to detect clicks outside the modal
    React.useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        // Cleanup the event listener when component unmounts
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen, onClose]);

    if (!isOpen) return null;

    return (
        <div className="fixed top-0 left-0 w-screen h-full md:w-full md:h-full flex justify-center items-center bg-black bg-opacity-50 z-50">
            <div ref={modalRef} className="relative bg-white p-8 rounded-lg shadow-lg w-[300px] md:w-[425px] mr-5 md:mr-0 md:max-w-md max-h-72 md:max-h-96 overflow-y-scroll">
                <button className="absolute top-2 right-5 text-gray-500 hover:text-gray-700 text-xl" onClick={onClose}>
                    &times;
                </button>
                <p>To save this form, create an account or sign in.</p>
                <div className="flex w-full justify-center gap-4 mt-4">
                    <button className="bg-shi-green text-white px-4 py-2 rounded mr-2" onClick={onCreateAccount}>Create Account</button>
                    <button className="bg-white border-shi-green hover:bg-slate-400 text-shi-green px-4 py-2 rounded" onClick={onSignIn}>Sign In</button>
                </div>
            </div>
        </div>
    );
};

export default ConfirmationModal;